import React from 'react';

const SvgCourseSchedule = props => (
  <svg data-name="Layer 1" viewBox="0 0 28.29 28.29" {...props}>
    <path d="M14.9 23.19V11.75h-3.99v1.5h2.49v9.94h-2.59v1.5h6.68v-1.5H14.9z" />
    <path d="M28.29 21.67V0H0v28.29h21.67zM1.5 10.05h25.33v10.56h-6.18v6.18H1.5V10.05zm25.29-1.5H1.5V1.5h25.33v7.05zm-4.68 13.56h3.62l-3.62 3.62v-3.62z" />
  </svg>
);

export default SvgCourseSchedule;
